import { CharacterAttack } from '../attacks/CharacterAttack';
import { CharacterBase } from '../CharacterBase';
import { CharacterEnemy } from '../CharacterEnemy';

const CONFIG = {
  id: 'foreman',
  spineid: 'foreman',
  combatStyle: 'MELEE',
  speed: 150,
  health: 400,
  coins: 10,
  stagger: 0.25,
  knockdown: 0.5,
  attackRate: 1.5,
  attackRange: 250,
  attacks: [],
  bodyCollider: { width: 175, height: 250, offsetX: 35 },
};

const ATTACKS = {
  uppercut: {
    id: 'uppercut',
    name: 'uppercut',
    animation: 'upper_cut_punch',
    damage: 40,
    knockdown: true,
  },
  groundslam: {
    id: 'ground_slam',
    name: 'ground_slam',
    animation: 'ground_slam',
    damage: 40,
    knockdown: true,
  },
  comboOne: {
    id: 'combo_one',
    name: 'combo_one',
    animation: 'attack_1',
    damage: 20,
  },
  comboTwo: {
    id: 'combo_two',
    name: 'combo_two',
    animation: 'combo_finisher',
    damage: 20,
  },
};

export class CharacterForeman extends CharacterEnemy {
  constructor(scene, x, y, config, collisionmap) {
    super(scene, x, y, CONFIG, collisionmap);

    this.attackCount = 0;
    this.attackGroundSlam = new CharacterAttack(scene, this, ATTACKS.groundslam);
    this.attackUppercut = new CharacterAttack(scene, this, ATTACKS.uppercut);
    this.attackComboOne = new CharacterAttack(scene, this, ATTACKS.comboOne);
    this.attackComboTwo = new CharacterAttack(scene, this, ATTACKS.comboTwo);
    this.isBoss = true;
  }

  handleSpineEvent(t, e) {
    super.handleSpineEvent(t, e);
    switch (e.data.name) {
      case 'sfx':
        this.scene.shake();
        break;
    }
  }

  chooseAttack() {
    const dx = Math.abs(this.x - this._heroTarget.x);
    const dy = Math.abs(this.y - this._heroTarget.y);

    if (dx > this.attackRange || dy > 3) return false;
    if (this.heroTarget.isJumping) return this.attackUppercut;
    this.attackCount++;
    return this.attackCount % 3 === 0 ? this.attackGroundSlam : this.attackComboOne;
  }

  handleAttackComplete() {
    if (this._attackActive == this.attackComboOne) {
      this._attackActive = this.attackComboTwo;
      this._velocity.x = this._velocity.y = 0;
      this._attackActive.trigger();
      this.setState(CharacterBase.STATES.ATTACK);
    } else super.handleAttackComplete();
  }

  knockdown() {}
}
